/**
 * Sprint 18 B4: Portal Layout — buyer-facing, no sidebar
 * Clean layout with minimal header (logo + user menu) for client portal.
 * Used for /portal/* routes — customers see their bookings, history, messages.
 */
import { Outlet, Link, useNavigate } from "react-router";
import { User, LogOut, Calendar, Clock, MessageSquare } from "lucide-react";
import { useState } from "react";

export function PortalLayout() {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="min-h-screen bg-[var(--color-surface)]">
      {/* Portal header */}
      <header className="sticky top-0 z-50 border-b border-[var(--color-border)] bg-[var(--color-background)]">
        <div className="mx-auto max-w-5xl flex items-center justify-between px-4 py-3">
          <Link to="/portal" className="text-lg font-semibold text-[var(--color-primary)]">
            My Portal
          </Link>

          <nav className="hidden sm:flex items-center gap-6">
            <Link to="/portal" className="flex items-center gap-1.5 text-sm text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)] transition-colors">
              <Calendar className="h-4 w-4" /> Bookings
            </Link>
            <Link to="/portal/history" className="flex items-center gap-1.5 text-sm text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)] transition-colors">
              <Clock className="h-4 w-4" /> History
            </Link>
            <Link to="/portal/messages" className="flex items-center gap-1.5 text-sm text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)] transition-colors">
              <MessageSquare className="h-4 w-4" /> Messages
            </Link>
          </nav>

          <div className="relative">
            <button
              type="button"
              onClick={() => setShowMenu(!showMenu)}
              className="rounded-full p-2 hover:bg-[var(--color-surface)] transition-colors"
            >
              <User className="h-5 w-5 text-[var(--color-muted-foreground)]" />
            </button>
            {showMenu && (
              <div className="absolute right-0 top-full mt-1 w-48 rounded-lg border border-[var(--color-border)] bg-[var(--color-background)] shadow-lg py-1 z-50">
                <button
                  type="button"
                  onClick={() => { setShowMenu(false); navigate("/login"); }}
                  className="flex w-full items-center gap-2 px-4 py-2 text-sm text-[var(--color-error)] hover:bg-[var(--color-surface)]"
                >
                  <LogOut className="h-4 w-4" /> Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Portal content */}
      <main className="mx-auto max-w-5xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
